<template>
  <div id='bd-main'>
    <el-table :data="userFeedbacks.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="user.nickname" label="姓名" width="185"></el-table-column>
      <el-table-column prop="mobile" label="手机"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="content" label="反馈内容"></el-table-column>
      <el-table-column prop="replyContent" label="回复"></el-table-column>
      <el-table-column prop="client" label="客户端"></el-table-column>
      <el-table-column prop="createdAt" label="反馈时间"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <!-- <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small">
            移除
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userFeedbacks.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'userFeedbacks' ])
  },
  methods: {
    ...mapActions([ 'queryFeedbacks' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.queryFeedbacks(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.queryFeedbacks(payload)
  },

}
</script>

<style scoped>

</style>
